import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

import { DriveFragmentDoc } from '../fragments.generated';

const defaultOptions = {} as const;
export type DriveQueryVariables = Types.Exact<{
  inputs: Types.GetDriveInputs;
}>;

export type DriveQuery = {
  __typename?: 'Query';
  drive?: {
    __typename?: 'UserDrive';
    id: string;
    teamId?: string | null;
    name: string;
    settings?: { __typename?: 'DriveSettings'; color?: string | null } | null;
    driveAccess: { __typename?: 'DriveAccessRole'; role: Types.DriveAccessRoleEnum };
  } | null;
};

export type GetDriveUsersQueryVariables = Types.Exact<{
  inputs: Types.GetDriveInputs;
}>;

export type GetDriveUsersQuery = {
  __typename?: 'Query';
  driveUsers: Array<{
    __typename?: 'DriveUser';
    id: string;
    role: Types.DriveAccessRoleEnum;
  }>;
};

export type UpdateDriveUsersAccessMutationVariables = Types.Exact<{
  inputs: Types.UpdateDriveUsersInputs;
}>;

export type UpdateDriveUsersAccessMutation = {
  __typename?: 'Mutation';
  updateDriveUsers: {
    __typename?: 'UpdateDriveUsersMutationResponse';
    code: string;
    success: boolean;
    message: string;
    driveUsers?: Array<{
      __typename?: 'DriveUser';
      id: string;
      role: Types.DriveAccessRoleEnum;
    } | null> | null;
  };
};

export type UpdateDriveMutationVariables = Types.Exact<{
  inputs: Types.UpdateDriveInputs;
}>;

export type UpdateDriveMutation = {
  __typename?: 'Mutation';
  updateDrive: {
    __typename?: 'UpdateDriveMutationResponse';
    code: string;
    success: boolean;
    message: string;
    drive?: {
      __typename?: 'UserDrive';
      id: string;
      teamId?: string | null;
      name: string;
      createdAt: string;
      updatedAt: string;
      driveType: Types.DriveTypeFromDb;
      settings?: { __typename?: 'DriveSettings'; color?: string | null } | null;
      driveAccess: { __typename?: 'DriveAccessRole'; role: Types.DriveAccessRoleEnum };
    } | null;
  };
};

export type DeleteDriveMutationVariables = Types.Exact<{
  inputs: Types.DeleteDriveInputs;
}>;

export type DeleteDriveMutation = {
  __typename?: 'Mutation';
  deleteDrive: {
    __typename?: 'DeleteDriveMutationResponse';
    code: string;
    success: boolean;
    message: string;
    driveId?: string | null;
  };
};

export const DriveDocument = gql`
  query drive($inputs: GetDriveInputs!) {
    drive(inputs: $inputs) {
      id
      teamId
      name
      settings {
        color
      }
      driveAccess {
        role
      }
    }
  }
`;

/**
 * __useDriveQuery__
 *
 * To run a query within a React component, call `useDriveQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriveQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDriveQuery(
  baseOptions: Apollo.QueryHookOptions<DriveQuery, DriveQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DriveQuery, DriveQueryVariables>(DriveDocument, options);
}
export function useDriveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DriveQuery, DriveQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DriveQuery, DriveQueryVariables>(DriveDocument, options);
}
export type DriveQueryHookResult = ReturnType<typeof useDriveQuery>;
export type DriveLazyQueryHookResult = ReturnType<typeof useDriveLazyQuery>;
export type DriveQueryResult = Apollo.QueryResult<DriveQuery, DriveQueryVariables>;
export const GetDriveUsersDocument = gql`
  query getDriveUsers($inputs: GetDriveInputs!) {
    driveUsers(inputs: $inputs) {
      id
      role
    }
  }
`;

/**
 * __useGetDriveUsersQuery__
 *
 * To run a query within a React component, call `useGetDriveUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriveUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriveUsersQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useGetDriveUsersQuery(
  baseOptions: Apollo.QueryHookOptions<GetDriveUsersQuery, GetDriveUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDriveUsersQuery, GetDriveUsersQueryVariables>(
    GetDriveUsersDocument,
    options
  );
}
export function useGetDriveUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDriveUsersQuery,
    GetDriveUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDriveUsersQuery, GetDriveUsersQueryVariables>(
    GetDriveUsersDocument,
    options
  );
}
export type GetDriveUsersQueryHookResult = ReturnType<typeof useGetDriveUsersQuery>;
export type GetDriveUsersLazyQueryHookResult = ReturnType<
  typeof useGetDriveUsersLazyQuery
>;
export type GetDriveUsersQueryResult = Apollo.QueryResult<
  GetDriveUsersQuery,
  GetDriveUsersQueryVariables
>;
export const UpdateDriveUsersAccessDocument = gql`
  mutation updateDriveUsersAccess($inputs: UpdateDriveUsersInputs!) {
    updateDriveUsers(inputs: $inputs) {
      code
      success
      message
      driveUsers {
        id
        role
      }
    }
  }
`;
export type UpdateDriveUsersAccessMutationFn = Apollo.MutationFunction<
  UpdateDriveUsersAccessMutation,
  UpdateDriveUsersAccessMutationVariables
>;

/**
 * __useUpdateDriveUsersAccessMutation__
 *
 * To run a mutation, you first call `useUpdateDriveUsersAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriveUsersAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriveUsersAccessMutation, { data, loading, error }] = useUpdateDriveUsersAccessMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateDriveUsersAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDriveUsersAccessMutation,
    UpdateDriveUsersAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDriveUsersAccessMutation,
    UpdateDriveUsersAccessMutationVariables
  >(UpdateDriveUsersAccessDocument, options);
}
export type UpdateDriveUsersAccessMutationHookResult = ReturnType<
  typeof useUpdateDriveUsersAccessMutation
>;
export type UpdateDriveUsersAccessMutationResult =
  Apollo.MutationResult<UpdateDriveUsersAccessMutation>;
export type UpdateDriveUsersAccessMutationOptions = Apollo.BaseMutationOptions<
  UpdateDriveUsersAccessMutation,
  UpdateDriveUsersAccessMutationVariables
>;
export const UpdateDriveDocument = gql`
  mutation updateDrive($inputs: UpdateDriveInputs!) {
    updateDrive(inputs: $inputs) {
      code
      success
      message
      drive {
        ...DriveFragment
      }
    }
  }
  ${DriveFragmentDoc}
`;
export type UpdateDriveMutationFn = Apollo.MutationFunction<
  UpdateDriveMutation,
  UpdateDriveMutationVariables
>;

/**
 * __useUpdateDriveMutation__
 *
 * To run a mutation, you first call `useUpdateDriveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriveMutation, { data, loading, error }] = useUpdateDriveMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateDriveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDriveMutation,
    UpdateDriveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateDriveMutation, UpdateDriveMutationVariables>(
    UpdateDriveDocument,
    options
  );
}
export type UpdateDriveMutationHookResult = ReturnType<typeof useUpdateDriveMutation>;
export type UpdateDriveMutationResult = Apollo.MutationResult<UpdateDriveMutation>;
export type UpdateDriveMutationOptions = Apollo.BaseMutationOptions<
  UpdateDriveMutation,
  UpdateDriveMutationVariables
>;
export const DeleteDriveDocument = gql`
  mutation deleteDrive($inputs: DeleteDriveInputs!) {
    deleteDrive(inputs: $inputs) {
      code
      success
      message
      driveId
    }
  }
`;
export type DeleteDriveMutationFn = Apollo.MutationFunction<
  DeleteDriveMutation,
  DeleteDriveMutationVariables
>;

/**
 * __useDeleteDriveMutation__
 *
 * To run a mutation, you first call `useDeleteDriveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriveMutation, { data, loading, error }] = useDeleteDriveMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDeleteDriveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDriveMutation,
    DeleteDriveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDriveMutation, DeleteDriveMutationVariables>(
    DeleteDriveDocument,
    options
  );
}
export type DeleteDriveMutationHookResult = ReturnType<typeof useDeleteDriveMutation>;
export type DeleteDriveMutationResult = Apollo.MutationResult<DeleteDriveMutation>;
export type DeleteDriveMutationOptions = Apollo.BaseMutationOptions<
  DeleteDriveMutation,
  DeleteDriveMutationVariables
>;
